import { LuBriefcase, LuContactRound, LuGraduationCap, LuIdCard } from 'react-icons/lu';

// Sections of the Add / Edit employee forms, in order.
const SECTIONS = [
  { id: 'personal', icon: LuIdCard, tint: 'tw-bg-teal-500/15 tw-text-teal-600 dark:tw-text-teal-300' },
  { id: 'contact', icon: LuContactRound, tint: 'tw-bg-sky-500/15 tw-text-sky-600 dark:tw-text-sky-300' },
  { id: 'employment', icon: LuBriefcase, tint: 'tw-bg-violet-500/15 tw-text-violet-600 dark:tw-text-violet-300' },
  { id: 'education', icon: LuGraduationCap, tint: 'tw-bg-amber-500/15 tw-text-amber-600 dark:tw-text-amber-300' },
];

/** Sections with their texts in the current language. */
export const getFormSections = (t) => SECTIONS.map((section) => ({
  ...section,
  label: t(`employees.form.${section.id}`),
  hint: t(`employees.form.${section.id}Hint`),
}));

/** Which section shows a field (to open it when the field has an error). */
export const FIELD_SECTIONS = {
  ID: 'personal',
  eName: 'personal',
  eSurname: 'personal',
  tcNumber: 'personal',
  eMail: 'contact',
  phone: 'contact',
  emergencyPhone: 'contact',
};

/** Error count per section, and the first section that has one. */
export const summarizeErrors = (errors) => {
  const counts = {};
  Object.keys(errors).forEach((field) => {
    if (!errors[field]) return;
    const section = FIELD_SECTIONS[field] || 'personal';
    counts[section] = (counts[section] || 0) + 1;
  });
  const first = SECTIONS.find((section) => counts[section.id]);
  return { counts, firstSection: first ? first.id : null };
};
